// Fecha de HOY en hora de Madrid (YYYY-MM-DD). Los borradores de compra se sellan con
// ella: con la fecha UTC (toISOString) lo hecho entre las 00:00 y las 02:00 de Madrid
// contaba como "de ayer" y se descartaba.
export const hoyMadrid = () => {
  try {
    return new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Madrid" });
  } catch (_) {
    return new Date().toISOString().slice(0, 10);
  }
};
